module.exports = __webpack_public_path__ + "static/media/accept_all.6bd07165.svg";